import { invalidateAfterUserGroupMemberMutation, noddiAsync, URLKeys } from 'noddi-async';
import type { CarManagerPatch } from './driverChangePlan';

/**
 * The one write behind every driver change, in both directions and for undo. One
 * request per car — the endpoint takes a single car — settled together so a refused
 * car cannot silently cancel the rest of the batch.
 */
export const useDriverChange = ({ userGroupId }: { userGroupId: number }) => {
  const { mutateAsync, isPending, error, reset } = noddiAsync.usePatch({
    type: URLKeys.patchUserGroupCarManagers,
    queryConfig: {
      // The flow shows its own outcome panel naming the cars, so the generic toast would precede it with less.
      meta: { suppressSuccessToast: true },
      onSuccess: () => invalidateAfterUserGroupMemberMutation({ userGroupId })
    }
  });

  const apply = async (patches: CarManagerPatch[]) => {
    reset();
    const results = await Promise.allSettled(patches.map((patch) => mutateAsync({ userGroupId, ...patch })));
    return results.every((result) => result.status === 'fulfilled');
  };

  return { apply, isPending, error };
};
